import { getDataProps } from './dataProps';

// todo: Handle bundle detail view?
export const sellerDetailView = (adId: number) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusSell}/${adId}`;
};

export const buyerDetailView = (transactionId: string) => {
    const { urls } = getDataProps();
    return `${urls.internal.statusBuy}/${transactionId}`;
};
